/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerNetworkLockPolicyDto } from '../models/EntityModelResponseContainerNetworkLockPolicyDto';
import type { NetworkLockPolicyDto } from '../models/NetworkLockPolicyDto';
import type { PagedModelEntityModelNetworkLockPolicyDto } from '../models/PagedModelEntityModelNetworkLockPolicyDto';
import type { PagedResourcesAssemblerNetworkLockPolicyDto } from '../models/PagedResourcesAssemblerNetworkLockPolicyDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NetworkLockPolicyControllerService {
    /**
     * @returns PagedModelEntityModelNetworkLockPolicyDto OK
     * @throws ApiError
     */
    public static listAll({
        assembler,
        page,
        size = 20,
        sort,
    }: {
        assembler: PagedResourcesAssemblerNetworkLockPolicyDto,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelNetworkLockPolicyDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/network-lock-policies',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns PagedModelEntityModelNetworkLockPolicyDto OK
     * @throws ApiError
     */
    public static list({
        operatorId,
        assembler,
        name,
        page,
        size = 20,
        sort,
    }: {
        operatorId: number,
        assembler: PagedResourcesAssemblerNetworkLockPolicyDto,
        name?: string,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelNetworkLockPolicyDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/operators/{operatorId}/network-lock-policies',
            path: {
                'operatorId': operatorId,
            },
            query: {
                'name': name,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerNetworkLockPolicyDto OK
     * @throws ApiError
     */
    public static create({
        operatorId,
        requestBody,
    }: {
        operatorId: number,
        requestBody: NetworkLockPolicyDto,
    }): CancelablePromise<EntityModelResponseContainerNetworkLockPolicyDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/operators/{operatorId}/network-lock-policies',
            path: {
                'operatorId': operatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        operatorId,
        policyId,
    }: {
        operatorId: number,
        policyId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/program/operators/{operatorId}/network-lock-policies/{policyId}',
            path: {
                'operatorId': operatorId,
                'policyId': policyId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerNetworkLockPolicyDto OK
     * @throws ApiError
     */
    public static read({
        operatorId,
        policyId,
    }: {
        operatorId: number,
        policyId: number,
    }): CancelablePromise<EntityModelResponseContainerNetworkLockPolicyDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/operators/{operatorId}/network-lock-policies/{policyId}',
            path: {
                'operatorId': operatorId,
                'policyId': policyId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerNetworkLockPolicyDto OK
     * @throws ApiError
     */
    public static update({
        operatorId,
        policyId,
        requestBody,
    }: {
        operatorId: number,
        policyId: number,
        requestBody: NetworkLockPolicyDto,
    }): CancelablePromise<EntityModelResponseContainerNetworkLockPolicyDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/program/operators/{operatorId}/network-lock-policies/{policyId}',
            path: {
                'operatorId': operatorId,
                'policyId': policyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
